module.exports = __webpack_public_path__ + "static/media/visual-grammar-img-003.b37231f1.jpg";